import { useEffect, useState } from "react";
import TitleBar from "../components/TitleBar/TitleBar";

import "./AdminConfig.css";

interface AdminConfigData {
    discordInvite: string;
}

export function AdminConfig() {
    const [discordInvite, setDiscordInvite] = useState<string>("");
    const [saved, setSaved] = useState<boolean>(false);

    const doSave = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await fetch(
                `${import.meta.env.VITE_SERVER_URL}/api/admin/save`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        discordInvite: discordInvite,
                    }),
                },
            );

            if (!response.ok) {
                console.error("Failed to save config:", response.statusText);
                return;
            }

            const responseData = await response.json();

            if (!responseData.ok) {
                console.error("Error in response data:", responseData.message);
                return;
            } else {
                setSaved(true);
                console.log("Config saved successfully");
            }
        } catch (error) {
            console.error("Error saving config:", error);
            return;
        }
    };

    useEffect(() => {
        document.title = "Admin Configuration - Mythic Site";
        // Fetch the current admin configuration
        fetch(`${import.meta.env.VITE_SERVER_URL}/api/admin/getconfig`, {
            method: "GET",
            credentials: "include",
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setDiscordInvite(data.discordInvite);
                console.log(data);
            })
            .catch((error) => console.error("Error fetching config:", error));
    }, []);

    return (
        <>
            <TitleBar title="Mythic Shop" />
            <div className="admin-config-page">
                <h1>Admin Configuration</h1>
                <form className="admin-config-form">
                    {saved && (
                        <p className="save-success-message">
                            Configuration saved!
                        </p>
                    )}
                    <label htmlFor="discord-link">Discord Link:</label>
                    <input
                        type="text"
                        id="discord-link"
                        name="discord-link"
                        placeholder=""
                        defaultValue={discordInvite}
                        onChange={(e) => {
                            setDiscordInvite(e.target.value);
                            setSaved(false);
                        }}
                    />
                    <button type="submit" onClick={doSave}>
                        Save Configuration
                    </button>
                </form>
            </div>
        </>
    );
}
